import { createSelector } from '@reduxjs/toolkit';
import { SLICE } from 'modules/dashboard/constants';
import { initialState } from './slice';

const selectDomain = (state) => state[SLICE.CUSTOM_CHAT] || initialState;

export const selectChatLoading = createSelector([selectDomain], (state) => state.loading);
export const selectChatResponse = createSelector([selectDomain], (state) => state.response);
export const selectChatError = createSelector([selectDomain], (state) => state.error);
